import { Component, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { EAccountRole, ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ToastService } from 'src/app/shared/services/toast.service';
import { RolesService } from '../../services/roles.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-add-new-role',
  templateUrl: './add-new-role.component.html',
  styleUrls: ['./add-new-role.component.scss']
})
export class AddNewRoleComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  addPerfil = new UntypedFormGroup({
    active: new UntypedFormControl(true),
    description: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
    comments: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
    adminOlive: new UntypedFormControl(0)
  });

  isAdmOlive = false;

  formAberto = false;

  constructor(
    private readonly rolesService: RolesService,
    private readonly router: Router,
    private readonly toastr: ToastService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.isAdmOlive = this.sessionService.getSession().accountRole == EAccountRole.Admin.toString();
  }

  convertCheckboxValue(): void {
    const adminOliveValue = this.addPerfil.get('adminOlive')?.value;
    this.addPerfil.get('adminOlive')?.setValue(adminOliveValue ? 1 : 0);
  }

  salvarPerfil(): void {
    if (this.addPerfil.invalid) {
      this.toastr.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.addPerfil.markAllAsTouched();
      return;
    }

    const perfil = this.addPerfil.getRawValue();
    this.rolesService.addPerfil(perfil).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length) {
        this.toastr.toast(resposta.messages);
      }

      if (resposta.isSucceed) {
        this.router.navigateByUrl(`dash/papeis/gerenciamento/${resposta.data}`);
      }
    });
  }
}
